<template>
    <div class="flex flex-row w-full">
      <div class="pl-1.5 pt-0.5 flex flex-col w-2/4">   
        <div class="flex flex-row justify-start w-full mb-1">
          <ClientContactBusinessEmailCell :client-contact="clientRelationship" @refetch-clients="fetchNewContacts">
            <template #icon>
              <span class="font-bold pr-1"><img id="email" src="@/assets/images/icons8-email-30.png" alt="email" class="w-[16px] inline"/></span>
            </template>
          </ClientContactBusinessEmailCell>
        </div>
        <div class="flex flex-row justify-start w-ful mb-1">
          <ClientContactBusinessPhoneCell :client-contact="clientRelationship" @refetch-clients="fetchNewContacts">
            <template #icon>
              <span class="font-bold pr-1"><img id="phone" src="@/assets/images/icons8-phone-30.png" alt="phone" class="w-[16px] inline"/></span>
            </template>
          </ClientContactBusinessPhoneCell>
        </div>
      </div>
      <div class="pl-1.5 pt-0.5 flex flex-col w-2/4">
        <div class="flex flex-row justify-start w-full mb-1">
          <ClientContactBusinessNotesCell :client-contact="clientRelationship" @refetch-clients="fetchNewContacts">
            <template #icon>
              <span class="pr-1"><img id="notes" src="@/assets/images/icons8-notes-50.png" alt="notes" class="w-[16px] inline"/></span>
            </template>
          </ClientContactBusinessNotesCell>
        </div>
        <div class="flex flex-row justify-start items-center align-middle w-full mb-1">
          <span class="pr-1"><img id="notes" src="@/assets/images/icons8-star-50.png" alt="primary" class="w-[16px] inline"/></span>
          <ClientContactIsPrimaryCell :client-contact="clientRelationship" @refetch-clients="fetchNewContacts" />
        </div>
      </div>
    </div>
    </template>
    
  <script setup>
  import { defineProps, defineEmits } from 'vue';
  import ClientContactBusinessEmailCell from '@/components/clients_page/client-contact-components/ClientContactBusinessEmailCell.vue';
  import ClientContactBusinessPhoneCell from '@/components/clients_page/client-contact-components/ClientContactBusinessPhoneCell.vue';
  import ClientContactBusinessNotesCell from '@/components/clients_page/client-contact-components/ClientContactBusinessNotesCell.vue';
  import ClientContactIsPrimaryCell from '@/components/clients_page/client-contact-components/ClientContactIsPrimaryCell.vue';
  const props = defineProps(['clientRelationship'])
  
  const emit = defineEmits(['refetch-contacts'])
  
  const fetchNewContacts = () => {
    emit('refetch-contacts')
  }
  </script>